const basePath = process.env.NEXT_PUBLIC_BASE_PATH || '';

export function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text);
}

export const defaultHeaders = {
  'Content-Type': 'application/json',
};

export const fetcher = async (url: string, queryParams = '') => {
  const res = await fetch(`${basePath}${url}${queryParams}`);

  let resContent, pageToken;

  try {
    resContent = await res.clone().json();
    pageToken = res.headers.get('jackson-pagetoken');
    if (pageToken !== null) {
      return { ...resContent, pageToken };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    resContent = await res.clone().text();
  }

  if (!res.ok) {
    const error = new Error(
      (resContent.error.message as string) || 'An error occurred while fetching the data.'
    );

    throw error;
  }

  return resContent;
};

export const addQueryParamsToPath = (path: string, queryParams: Record<string, any>) => {
  const hasQuery = path.includes('?');

  const queryString = Object.keys(queryParams)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
    .join('&');

  const newPath = hasQuery ? `${path}&${queryString}` : `${path}?${queryString}`;

  return newPath;
};

export const formatXml = (xml: string): string => {
  const PADDING = '  '; // set desired indentation
  const reg = /(>)(<)(\/*)/g;
  let formatted = '';
  let pad = 0;

  xml = xml.replace(reg, '$1\r\n$2$3');
  xml.split('\r\n').forEach((node) => {
    let indent = 0;
    if (node.match(/.+<\/\w[^>]*>$/)) {
      indent = 0;
    } else if (node.match(/^<\/\w/)) {
      if (pad !== 0) pad -= 1;
    } else if (node.match(/^<\w([^>]*[^/])?>.*$/)) {
      indent = 1;
    } else {
      indent = 0;
    }

    formatted += PADDING.repeat(pad) + node + '\r\n';
    pad += indent;
  });

  return formatted.trim();
}

